import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import Api from '../services/Api'
import ApiCaller from '../services/ApiCaller';
import { call } from 'redux-saga/effects'
import {
  Panel, FormControl, Col,
  PanelContainer, Row, Button, Icon
} from '@sketchpixy/rubix'
import {
  DEFAULT_DATE_TIME_FORMAT
} from '../utils/index'
import moment from 'moment';
import LoadingContainer from "../components/LoadingContainer";

const api = Api.apiCreate(process.env.API_URL)

class ListDbqs extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: "21-0960M-2",
      file: "",
      fileLinkIndex: 0,
      message: "",
      loading: false,
      success: false,
      fields: [],
      selectedOptions: [],
      charCount: 100,
      zipFile:"",
      dbqFilePaths: [],
      version: "new",
      dbqListOptions: [
        {
          "value": "all",
          "label": "Select All"
        },
        {
            "value": "21-0960M-2",
            "label": "Ankle Disabilities"
        },
        {
            "value": "21-0960L-1",
            "label": "Asthma, Sarcoidosis, etc."
        },
        {
            "value": "21-0960M-14",
            "label": "Back Disabilities"
        },
        {
            "value": "21-0960J-4",
            "label": "Bladder Disabilities, Urinary Tract Infection, etc."
        },
        {
            "value": "21-0960E-1",
            "label": "Diabetes"
        },
        {
            "value": "21-0960C-4",
            "label": "Diabetic Neuropathy"
        },
        {
            "value": "21-0960M-4",
            "label": "Elbow Disabilities"
        },
        {
            "value": "21-0960J-2",
            "label": "Male Reproductive Organ"
        },
        {
            "value": "21-0960C-7",
            "label": "Fibromyalgia"
        },
        {
            "value": "21-0960G-1",
            "label": "GERD, Hiatal Hernia, etc."
        },
        {
            "value": "21-0960M-3",
            "label": "Gout"
        },
        {
            "value": "21-0960M-7",
            "label": "Hand and Fingers"
        },
        {
            "value": "21-0960A-4",
            "label": "Heart Disabilities"
        },
        {
            "value": "21-0960H-2",
            "label": "Hemorrhoids"
        },
        {
            "value": "21-0960G-5",
            "label": "Hepatitis"
        },
        {
            "value": "21-0960M-8",
            "label": "Hip Disabilities"
        },
        {
            "value": "21-0960G-3",
            "label": "IBS"
        },
        {
            "value": "21-0960J-1",
            "label": "Kidney Disease, Kidney Stones, etc"
        },
        {
            "value": "21-0960M-9",
            "label": "Knee Disabilities"
        },
        {
            "value": "21-0960P-2",
            "label": "Mental Disorders other than PTSD"
        },
        {
            "value": "21-0960C-8",
            "label": "Migraines, Tension Headaches, etc."
        },
        {
            "value": "21-0960C-9",
            "label": "Multiple Sclerosis"
        },
        {
            "value": "21-0960M-13",
            "label": "Neck Disabilities"
        },
        {
            "value": "21-0960C-10",
            "label": "Nerve Disabilities"
        },
        {
            "value": "21-0960M-6",
            "label": "Pes Planus or Plantar Fasciitis"
        },
        {
            "value": "21-0960J-3",
            "label": "Prostate Cancer"
        },
        {
            "value": "21-0960P-3",
            "label": "PTSD"
        },
        {
            "value": "21-0960F-1",
            "label": "Scars"
        },
        {
            "value": "21-0960C-11",
            "label": "Seizure Disorders"
        },
        {
            "value": "21-0960M-12",
            "label": "Shoulder Disabilities"
        },
        {
            "value": "21-0960N-4",
            "label": "Sinusitis"
        },
        {
            "value": "21-0960F-2",
            "label": "Skin Diseases"
        },
        {
            "value": "21-0960L-2",
            "label": "Sleep Apnea"
        },
        {
            "value": "21-0960A-2",
            "label": "Varicose Veins, Peripheral Vascular Disease, etc."
        },
        {
            "value": "21-0960M-16",
            "label": "Wrist Conditions"
        }
    ],
    }
  }

  componentDidMount() {
}

handleChange = (event) => {
    this.setState({ value: event.target.value, fileLinkIndex: 0, message: "" });
};

testScript = () => {
    const { selectedOptions, dbqListOptions, charCount, version } = this.state
    let optionsToSend = []
    if (selectedOptions && selectedOptions.value && selectedOptions.value === "all") {
      optionsToSend = dbqListOptions.slice(1, dbqListOptions.length)
    } else {
      optionsToSend = selectedOptions
    }
   
    if (optionsToSend) {
        this.setState({ loading: true, message: "", dbqFilePaths: [], fileLinkIndex:0});
       let token = localStorage.getItem('login_token');
       let headers = {'Content-Type': 'application/json'};
       headers["Authorization"] = `Bearer ${token}`
   
      let fd = {"dbqOptions": optionsToSend, version: version, charCount: charCount && charCount > 0 ? charCount : 5 }
   
       fetch(process.env.API_URL+"/patients/script", {method: 'POST', body: JSON.stringify(fd), headers} )
       .then(response => response.json())
       .then(data => {
         //if (data.success) {
          this.setState({ dbqFilePaths: data.dbqFilePaths, zipFile: data.zipFile, loading: false, success: data.success, message: data.message})       
         //}
         console.log(data.dbqFilePaths)
       })
       .catch(err => {
            this.setState({ loading: false, message: err.message });
           console.error(err)
        });
    } else {
        alert("Please select DBQ for which file is to upload")
    }
   
   };

viewQuestion = (listItem) => {
  this.setState({questions: listItem.questions})
  window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
}
handleChangeSelect = (selectedOptions) => {
  let found = false;
  for (let opt of selectedOptions) {
    if (opt.value === "all") {
      found=true
    }
  } 
  if (found) {
    this.setState({selectedOptions: this.state.dbqListOptions[0]})
  } else {
    this.setState({selectedOptions})
  }
}
 navigate = (val) => {
  if (val === "dec" && this.state.fileLinkIndex>0) {
    this.setState({fileLinkIndex: this.state.fileLinkIndex-1})
  }
  if (val === "inc" && this.state.dbqFilePaths && this.state.fileLinkIndex < this.state.dbqFilePaths.length-1) {
    this.setState({fileLinkIndex: this.state.fileLinkIndex+1})
  }  
}
  render () {
    const { dbqListOptions, value, fileLinkIndex, loading, success, message, fields, dbqFilePaths } = this.state
    
    return (
      <div className={'home-containers'} >
          <Row>
          {loading && <LoadingContainer/>}
            <div className="col-sm-6">
              <Select options={dbqListOptions} isMulti={true} onChange={this.handleChangeSelect} value={this.state.selectedOptions} />           
            </div> 
            <div className="col-sm-1">
              <input type="text" onChange={(e) => this.setState({charCount: e.target.value})} value={this.state.charCount} className="script-char-count-text"></input>
            </div> 
            <div className="col-sm-2" >
              <select onChange={(e) => this.setState({version: e.target.value})} className="script-char-count-text">
                <option value="new">Latest version</option>
                <option value="old">Previous version</option>
              </select>
            </div>   
            <div className="col-sm-2">
                <Button
                    sm
                    type='button'
                    bsStyle='success'
                    style={{lineHeight: 2.9}}
                    onClick={this.testScript}>Go
                </Button>
            </div>
          </Row>
          <br /> 
          <Row>
          <div className="col-xs-12">
            
            {dbqFilePaths && dbqFilePaths.length>1 && 
            <div className="col-sm-6">
              <Icon style={{margin: '10px', cursor: 'pointer'}} glyph='glyphicon glyphicon-chevron-left' onClick={() => this.navigate("dec")}/>
              <span>{this.state.fileLinkIndex+1} / {dbqFilePaths.length}</span>
              <Icon style={{margin: '10px', cursor: 'pointer'}} glyph='glyphicon glyphicon-chevron-right' onClick={() => this.navigate("inc")}/>
            </div>}
            {dbqFilePaths && dbqFilePaths.length>0 && 
            <div className={dbqFilePaths.length > 1 ? 'col-sm-6' : 'col-sm-12'}>
              <a href={`${this.state.zipFile}`} target="_blank" download="TestDbqs.zip" className='pull-right'><Icon glyph='glyphicon glyphicon-download-alt' style={{margin: '10px'}}></Icon>Download</a>
            </div>}
            
            {
                dbqFilePaths && dbqFilePaths.length>0 && <object width="100%" height="600" data={dbqFilePaths[fileLinkIndex].path} type="application/pdf">   </object>
            }
            {
                message && <p style={success? {color: 'green', fontWeight: 'bold', fontSize: '20'} :{color: 'red', fontSize: '20'}}>{message}</p>
            }
          </div>
          <div className="col-xs-12">
          <div className="col-xs-6">
          {fields && fields.length>0 &&<h3>Fastvet DBQ Field Names are not in DBQ file:</h3>}
          {fields && fields.length>0 && fields.map(name => {
            return <p>{name}</p>
          }) }
          </div>
          <div className="col-xs-6">
        
          </div>
          </div>
          </Row>       
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps =
  ({
     login: {
       role
     }
   }) => ({
    role
  })

export default connect(mapStateToProps, mapDispatchToProps)(ListDbqs)
